module.exports = __webpack_public_path__ + "static/img/qrcode.97d19e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qrcode.jpg
// module id = Ftoc
// module chunks = 1